import { Typography, Container, Card, CardContent, Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
	const navigate = useNavigate();


	const handleViewContact = (contact: any) => {
		// Navigate to contacts page and open detail dialog
		navigate('/dashboard/contacts');
	};

	const handleViewAllContacts = () => {
		navigate('/dashboard/contacts');
	};

	return (
		<Container maxWidth="lg" sx={{ mt: 8 }}>
			<Typography variant="h4" gutterBottom>
				Admin Dashboard
			</Typography>
			<Typography variant="body1" sx={{ mb: 4 }}>
				Добро пожаловать в административную панель!
			</Typography>
		</Container>
	);
}
